/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable react-hooks/exhaustive-deps */
'use client';
import { Empty } from 'antd';
import clsx from 'clsx';
import { AnimatePresence, motion } from 'framer-motion';
import Image from 'next/image';
import { useSearchParams } from 'next/navigation';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { SwiperClass } from 'swiper/react';
import useSWR from 'swr';

import { getGames, getJackpot } from '@/lib/apis';
import {
  cateMapping,
  findCateByName,
  getDataLocal,
  getParameterByName,
  hotMapping,
  mapLabelFilterProvider,
  mapValueFilterProvider,
  saveLocalByKey,
  sortByJackpot,
  updateQueryStringParameters,
} from '@/lib/utils';

import ScrollToTop from '@/components/core/ScrollToTop';
import useClientTranslation from '@/components/hooks/useClientTranslation';
// import useClientTranslation from '@/components/hooks/useClientTranslation';
import useIntersectionObserver from '@/components/hooks/useIntersectionObserver';
import useIsMobile from '@/components/hooks/useScreenSize';

import ItemLive from '@/app/[lng]/(general)/game/provider/[...id]/components/PC/ItemLive';
import FilterCates from '@/app/[lng]/(home)/components/Mobile/components/FilterCates';
import {
  hearted,
  lobby,
  recentPlay,
} from '@/app/[lng]/(home)/components/Mobile/components/Renderer/RenderCateItemGames';
import { LobbyCate, lobbyCateProvider } from '@/constant/data';
import { liveCasinoLobby } from '@/constant/gameLobby';

export const TIME_JACKPOT = 20000;
export const LIMIT_GAME = 84;
const GameListPage = ({
  initialItems,
  currentTab,
  pagination,
  params,
}: {
  initialItems: any;
  params: any;
  currentTab: any;
  pagination: any;
}) => {
  const { t } = useClientTranslation('AccountPage');
  const [partnerProviderParam] = params?.id || [];
  const searchParams = useSearchParams();
  const partnerProviderSearchParam = searchParams.get('partner-provider');
  const categorySearchParam = searchParams.get('category');
  const isMobile = useIsMobile();
  const categoryParam = partnerProviderParam
    ? 'all'
    : findCateByName(getParameterByName('cate-detail') || '')?.value ||
      categorySearchParam;
  const slug = currentTab?.slug;
  const display = currentTab?.display;

  const defaultProvider =
    partnerProviderSearchParam || partnerProviderParam || '';
  {
    /* TODO: TBU */
  }
  const [selectValue] = useState(defaultProvider);
  const [cateDetail, setCateDetail] = useState(categoryParam || 'all');
  const [providerGames, setProviderGames] = useState(initialItems);
  const [page, setPage] = useState<any>(1);
  const [isNextLoading, setIsNextLoading] = useState(false);
  const swiperRef = useRef<SwiperClass | null>(null);
  const isLocalCache =
    cateDetail === hearted || cateDetail === recentPlay || cateDetail === lobby;

  const initWithSSR = useRef(0);
  const sentinelRef = useRef(null);
  const pageRef = useRef(1);
  const isJackpot = ['casino', 'fishing', 'slots'].includes(slug);

  const [_, setHeartBasket] = useState(
    getDataLocal(hearted)?.[`${slug}`] || []
  );

  // const games = useMemo(
  //   () =>
  //     getDataLocal(hearted)?.[`${slug}`]?.length > 0
  //       ? sortByHearted(providerGames, getDataLocal(hearted)?.[`${slug}`])
  //       : providerGames,
  //   [providerGames, cateDetail]
  // );

  const refreshJackpot = () => {
    return isJackpot ? getJackpot() : null;
  };
  const { data: jackpotResponse } = useSWR(
    '/get-jackpot' + slug,
    refreshJackpot,
    {
      refreshInterval: TIME_JACKPOT,
    }
  );

  const jackpot = jackpotResponse?.data;

  const gamesFilter: any = useMemo(() => {
    if (cateDetail === hearted) return getDataLocal(hearted)?.[`${slug}`];
    if (cateDetail === recentPlay) return getDataLocal(recentPlay)?.[`${slug}`];

    if (cateDetail === lobby)
      return !selectValue
        ? liveCasinoLobby
        : liveCasinoLobby.filter(
            (item) => item.partner_provider === selectValue
          );

    // if (isJackpot) {
    //   //jackpot
    //   return sortByHearted(
    //     sortByJackpot(providerGames, jackpot, Number(cateDetail) === 11),
    //     getDataLocal(hearted)?.[`${slug}`]
    //   );
    // }
    if (Number(cateDetail) === 11)
      return sortByJackpot(providerGames, jackpot, Number(cateDetail) === 11);

    // {
    //jackpot
    // return sortByHearted(
    // getDataLocal(hearted)?.[`${slug}`]
    // );
    // }

    return providerGames;
  }, [cateDetail, providerGames, slug, jackpot]);

  // if (initialItems?.length > 0 && initWithSSR.current === 0) {
  //   initWithSSR.current = 1;
  // }

  const isPreventClientCall =
    (initialItems?.length > 0 && initWithSSR.current === 0) ||
    cateDetail === recentPlay ||
    cateDetail === hearted ||
    cateDetail === lobby;

  console.log('initialItems:', initialItems);
  console.log('isPreventClientCall:', isPreventClientCall);
  const { data, isLoading, mutate, isValidating } = useSWR(
    !isPreventClientCall
      ? '/get-games' + selectValue + display + cateDetail
      : null,
    () => {
      return getGames({
        limit: LIMIT_GAME,
        partner: mapValueFilterProvider(selectValue),
        device: isMobile ? 'mobile' : 'pc',
        display:
          cateMapping(cateDetail) === 'hot'
            ? `17,${hotMapping(display)}`
            : hotMapping(display),
        display_all: cateMapping(cateDetail) === 'hot',
        category_id: cateMapping(cateDetail),
        page: pageRef.current,
      });
    },
    {
      revalidateOnFocus: false,
      revalidateOnMount: !isPreventClientCall,
    }
  );
  const hasNext =
    (data?.data?.meta?.totalPages ||
      page?.totalPages ||
      pagination?.totalPages) >
    (data?.data?.meta?.currentPage ||
      page?.currentPage ||
      pagination?.currentPage);

  // const loading = (Boolean(isLoading) || Boolean(isValidating)) && !gamesFilter;

  const loading = useMemo(
    () => Boolean(isLoading) || Boolean(isValidating),
    [gamesFilter, isLoading, isValidating]
  );

  const fetchMoreData = useCallback(async () => {
    try {
      setIsNextLoading(true);
      pageRef.current = pageRef.current + 1;
      const newDataResponse = await getGames({
        limit: LIMIT_GAME,
        partner: selectValue,
        device: isMobile ? 'mobile' : 'pc',
        display: display,
        category_id: cateMapping(cateDetail),
        page: pageRef.current, // Incremented page number
      });
      mutate((prevData) => {
        const items = [
          ...(prevData?.data?.items || []),
          ...(newDataResponse?.data?.items || []),
        ];
        const data = {
          ...(newDataResponse?.data || {}),
          items,
        };
        const newData = {
          ...(newDataResponse || {}),
          data,
        };

        return newData;
      }, false);
      setProviderGames((prev = []) => [
        // ...(prevData?.data?.items ||[]),
        // ...items,
        ...prev,
        ...(newDataResponse?.data?.items || []),
      ]);
      setPage(newDataResponse?.data?.meta);
    } catch (error) {
      console.error('fetchMoreData failure by ', error);
    } finally {
      setIsNextLoading(false);
    }
  }, [isMobile, display, mutate, selectValue, pageRef, isNextLoading]);

  useEffect(() => {
    setProviderGames(isPreventClientCall ? initialItems : data?.data?.items);
  }, [data, initialItems, isPreventClientCall]);

  const slugMapping =
    LobbyCate?.[hotMapping(selectValue)]?.slug ||
    LobbyCate?.[currentTab?.display]?.slug ||
    LobbyCate[Object.keys(LobbyCate)[0]].slug;

  const options = useMemo(
    () =>
      (lobbyCateProvider?.[display]?.partner_provider || [])?.map((_: any) => {
        return {
          label: (
            <span className='mr-3 capitalize' key={_}>
              {mapLabelFilterProvider(_, { isFormat: true })}
            </span>
          ),
          img: (
            <div className='logo rounded-lg' key={_}>
              <img
                className='w-6'
                src={`/img/game/banner/logo-provider/${_}.png`}
                alt=''
              />
            </div>
          ),
          value: _,
        };
      }),
    [display]
  );

  useEffect(() => {
    if (defaultProvider && swiperRef.current) {
      const index = lobbyCateProvider?.[display]?.partner_provider?.findIndex(
        (_: string) => _ == defaultProvider
      );
      if (index !== 0 && index !== -1 && options?.length > 8)
        swiperRef.current.slideTo(index + 1, 300);
    }
  }, [defaultProvider, display]);

  useIntersectionObserver(
    sentinelRef,
    (entry) => {
      if (entry.isIntersecting && hasNext && !isNextLoading) {
        fetchMoreData();
      }
    },
    {
      threshold: 0.25,
    }
  );

  return (
    <>
      <ScrollToTop />

      <div
        style={{
          backgroundImage: 'url("/img/common/banner_bg_game.png")',
          // backgroundRepeat: 'repeat-y',
          // backgroundSize: 'contain',
          // backgroundSize: 'cover',
        }}
        className={clsx(
          'md:!main-content relative h-full min-h-[800px] px-6'
          // gamesFilter?.length > 0 && 'flash'
        )}
      >
        <div className='container-pc  relative py-6'>
          <div className='relative h-[160px] w-full overflow-hidden !rounded-lg bg-[#2e1e1f] px-1'>
            <Image
              priority
              width={1440}
              height={160}
              className='h-full w-full !rounded-lg object-cover'
              src={`/img/game/banner/${slugMapping}.png`}
              alt='bg-provider'
            />
          </div>
          {/* TODO: TBU */}
          {/* <h2 className='mt-6 flex items-center'>
            <div className='container-pc w-full'>
              <Swiper
                className='!w-full !min-w-full'
                slidesData={[{ label: t('allProvider'), value: '' }].concat(
                  options
                )}
                options={{
                  onSwiper: (swiper) => {
                    swiperRef.current = swiper;
                  },
                  wrapperClass: 'w-full gap-1 py-1',
                  modules: [FreeMode],
                  freeMode: {
                    enabled: true,
                  },
                  slidesPerView: 'auto',
                  loop: false,
                  centeredSlides: true,
                  centeredSlidesBounds: true,
                  slideToClickedSlide: options?.length > 8,
                  slidesOffsetAfter: 80,
                }}
                customRenderSlide={(slideItem: any, index?: number) => {
                  const isActive = selectValue === slideItem.value;
                  return (
                    <SwiperSlide
                      onClick={() => {
                        setSelectValue(slideItem.value);
                        if (slideItem.value === '') {
                          setCateDetail('hot');
                        } else {
                          setCateDetail('all');
                        }
                        pageRef.current = 1;
                        initWithSSR.current += 1;
                        const searchParams = {
                          'partner-provider': slideItem.value,
                          category: slideItem.value === '' ? 'hot' : 'all',
                        };
                        window.history.replaceState(
                          null,
                          '',
                          updateQueryStringParameters(
                            window.location.href,
                            searchParams,
                            false
                          )
                        );
                      }}
                      className={clsx(
                        '!shadow-9 !bg-linear-16 text-14 group box-content flex !h-[45px] !max-w-[150px]  items-center justify-center !rounded-2xl !border font-bold text-[#fcfcfc]',
                        'hover:!text-main-pri hover:!bg-linear-17 hover:!border hover:border-white  hover:transition-all',
                        isActive &&
                          '!text-main-pri !bg-linear-17 !border border-white  transition-all'
                      )}
                      key={index}
                    >
                      <div className='flex items-center ' key={_}>
                        <span
                          className={clsx(
                            isActive ? 'opacity-[1]' : 'opacity-[0.7]'
                          )}
                        >
                          {slideItem.label}
                        </span>
                        <span
                          className={clsx(
                            'group-hover:grayscale-0',
                            isActive ? 'grayscale-0' : 'grayscale'
                          )}
                        >
                          {slideItem.img}
                        </span>
                      </div>
                    </SwiperSlide>
                  );
                }}
              ></Swiper>
            </div>
          </h2> */}
          <div>
            <FilterCates
              wrapperClass='!py-4 !ml-1'
              slideItemClassName='md:!min-h-[32px] font-bold !px-[15px]'
              textClassName='md:!text-14'
              items={currentTab}
              setCateDetail={(value: any) => {
                setCateDetail(value);
                const searchParams = {
                  category: value,
                };
                window.history.replaceState(
                  null,
                  '',
                  updateQueryStringParameters(
                    window.location.href,
                    searchParams,
                    false
                  )
                );
                pageRef.current = 1;
                initWithSSR.current += 1;
              }}
              cateDetail={cateDetail}
              // isShowAllCate={!selectValue}
            />
          </div>
          <div className='min-h-[55vh]'>
            <AnimatePresence initial={false}>
              {loading && (
                <div className='flex w-full flex-col items-center justify-center'>
                  <img
                    className='mt-60'
                    alt='logo'
                    src='/img/common/loading.svg'
                  />
                </div>
                // <motion.div
                //   initial={{ opacity: 0 }}
                //   animate={{ opacity: 1 }}
                //   transition={{ duration: 3 }}
                //   exit={{ opacity: 0 }}
                //   className='auto-fill-[200px_200px] mt-6 grid gap-4'
                // >
                //   <PlaceHolderGameLoading amount={18} />
                // </motion.div>
              )}
              {!loading && !gamesFilter?.length && (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  // transition={{ duration: 0.3 }}
                  exit={{ opacity: 0 }}
                  className='flex min-h-[55vh] flex-col items-center justify-center pb-2'
                >
                  <Empty description={t('nodata')}></Empty>
                </motion.div>
              )}
              {!loading && gamesFilter?.length > 0 && (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  // transition={{ duration: 3 }}
                  exit={{ opacity: 0 }}
                >
                  <InfiniteScroll
                    className='auto-fill-[200px_200px] mt-6 grid gap-4 !overflow-hidden pb-12 will-change-transform'
                    next={() => {}}
                    dataLength={gamesFilter ? gamesFilter.length : 0}
                    hasMore={hasNext}
                    loader={<></>}
                  >
                    {gamesFilter?.map((_: any) => {
                      return (
                        <motion.div
                          className='relative'
                          initial={{
                            opacity: 1,
                            y: 3,
                          }}
                          // transition={{ duration: 3 }}
                          animate={{
                            opacity: 1,
                            y: 0,
                          }}
                          key={_.id}
                        >
                          <div
                            className='!cursor-hand absolute left-[0] top-[0] z-[100] flex h-[18%] w-[18%] scale-[2.3] select-none items-center justify-center'
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              saveLocalByKey({
                                entryPointKey: hearted,
                                cate: slugMapping,
                                currentItem: _,
                                onRemovedData: (heartedStorageRemoved) => {
                                  setHeartBasket(heartedStorageRemoved);
                                },
                                onSavedData: (heartedStorageSaved) => {
                                  setHeartBasket(heartedStorageSaved);
                                },
                              });
                            }}
                          >
                            <div
                              className={clsx(
                                'heartContainer h-[65%] w-[65%]',
                                getDataLocal(hearted)?.[`${slugMapping}`]?.find(
                                  (h: any) => h?.id === _.id
                                ) && 'heartAnimated'
                              )}
                            />
                          </div>
                          <ItemLive
                            cate={slugMapping}
                            slotJackpotNumber={jackpot?.[_?.partner_game_id]}
                            item={_}
                          />
                        </motion.div>
                      );
                    })}
                  </InfiniteScroll>
                  {hasNext && !isLocalCache && (
                    <div
                      ref={sentinelRef}
                      className='flex w-full justify-center pb-6 text-center'
                    >
                      <img
                        className='mx-auto'
                        src='/img/common/loading.svg'
                        alt='loading'
                      />
                    </div>
                  )}
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </div>
      </div>
    </>
  );
};

export default GameListPage;
